import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close'

export const ExitButton = ({children, onClick}) => {
  return (
    <AtomButton
      color="primary"
      design={atomButtonDesigns.FLAT}
      leftIcon={<IconClose />}
      link
      onClick={onClick}
      size={atomButtonSizes.LARGE}
      shape={atomButtonShapes.CIRCULAR}
    >
      {children}
    </AtomButton>
  )
}

ExitButton.displayName = 'ExitButton'
ExitButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
}
